import React, { Component,  useState, useEffect  } from 'react';
import './EstruturaTO6.css';
import Fade from 'react-reveal/Fade';
import Zoom from 'react-reveal/Zoom';
import paredao_bueno from '../../assets/videos/paredao_bueno.mp4';
import interativo2Ativo1 from '../../assets/svgs/interativoAtivo 1.svg';        
import Dt2 from "../../assets/fundos/Dt2.jpg";
import controleremoto from '../../assets/svgs/Controle-01.svg';      
import $, { when } from "jquery";
import { debounce, throttle } from 'lodash';
import seta from '../../assets/svgs/more-white.svg';   

class EstruturaTO6 extends Component {
    componentDidMount() {

        if(window.matchMedia("(max-width: 600px)").matches){
    
        }
        else{
          if($( ".magazinenova" ).mousemove=true){
            $( ".magazinenova" ).mousemove(function( event ) {
            
              $("#TO6desapa").fadeIn();
        
              
            });
          }
          else{
            $("#TO6desapa").fadeOut();
    
          }
    
        }
    
    
    
        $("#TO6dimensao").click(function()
        
        {
          $(".menuuu").removeClass("todonone");
          $(".sidebar-wrapper").removeClass("show-sidebar", 500);
          $(".menuuu").addClass("todonone");
          $(".ffechar").addClass("todonone", 500);

          $("#TO6video").prop('muted', false);
          $("#TO6dimensao").addClass("todonone");
          $("#TO6dimensao2").removeClass("todonone");
          $("#TO6desapa2").addClass("todonone");
          $("#TO6video").addClass("pulo");

          $("#TO7dimensao").removeClass("todonone");
          $("#TO7desapa2").removeClass("todonone");
          $("#TO7obra1").removeClass("pulo");
          $("#TO7obra1").removeClass("pulo");
          $("#TO7video").removeClass("pulo");
          $("#TO7local1").removeClass("pulo");
          $("#TO7video").prop('muted', true);

          $("#TO8dimensao").removeClass("todonone");
          $("#TO8desapa2").removeClass("todonone");
          $("#TO8obra1").removeClass("pulo");
          $("#TO8obra1").removeClass("pulo");
          $("#TO8video").removeClass("pulo");
          $("#TO8local1").removeClass("pulo");
          $("#TO8video").prop('muted', true);

          $("#TO5dimensao").removeClass("todonone");
          $("#TO5desapa2").removeClass("todonone");
          $("#TO5obra1").removeClass("pulo");
          $("#TO5obra1").removeClass("pulo");
          $("#TO5video").removeClass("pulo");
          $("#TO5local1").removeClass("pulo");
          $("#TO5video").prop('muted', true);

          $("#TO4dimensao").removeClass("todonone");
          $("#TO4desapa2").removeClass("todonone");
          $("#TO4obra1").removeClass("pulo");
          $("#TO4obra1").removeClass("pulo");
          $("#TO4video").removeClass("pulo");
          $("#TO4local1").removeClass("pulo");
          $("#TO4video").prop('muted', true);

          $("#TO3dimensao").removeClass("todonone");
          $("#TO3desapa2").removeClass("todonone");
          $("#TO3obra1").removeClass("pulo");
          $("#TO3obra1").removeClass("pulo");
          $("#TO3video").removeClass("pulo");
          $("#TO3local1").removeClass("pulo");
          $("#TO3video").prop('muted', true);

          $("#TO2dimensao").removeClass("todonone");
          $("#TO2desapa2").removeClass("todonone");
          $("#TO2obra1").removeClass("pulo");
          $("#TO2obra1").removeClass("pulo");
          $("#TO2video").removeClass("pulo");
          $("#TO2local1").removeClass("pulo");
          $("#TO2video").prop('muted', true);

          $("#dimensao").removeClass("todonone");
          $("#desapa2").removeClass("todonone");
          $("#obra1").removeClass("pulo");
          $("#obra1").removeClass("pulo");
          $("#video").removeClass("pulo");
          $("#local1").removeClass("pulo");
          $("#video").prop('muted', true);
      
    
        }
        );
        $("#TO6dimensao2").click(function()
        
        {
          $(".menuuu").removeClass("todonone");
          $("#TO6video").prop('muted', true);
          $("#TO6dimensao2").addClass("todonone");
          $("#TO6dimensao").removeClass("todonone");
          $("#TO6desapa2").removeClass("todonone");
          $("#TO6obra1").removeClass("pulo");
          $("#TO6obra1").removeClass("pulo");
          $("#TO6video").removeClass("pulo");
          $("#TO6local1").removeClass("pulo");
        }
        );
    
    
        $("#TO6magazinenova").click(function(){
          $("#TO6desapa").delay('slow').fadeIn();
            
        
    
          setTimeout(
            function() 
            {
    
              
              var desaparecendo = 'todonone';
           
              $("#TO6desapa").fadeOut();
            }, 30000);
    
        });
    
        (function () {
    
          $("#TO6botomenu").click(function () {
            $( this ).slideUp().fadeOut(10000);
            $("#TO6hold1 ").addClass("cc");
            $("#TO6botoobras ").addClass("cc");
            $("#TO6hold3 ").addClass("cc");
            $("#TO6hold4 ").addClass("cc");
            $("#TO6hold5 ").addClass("cc");
            $("#TO6hold1 ").removeClass("transiopaca");
            $("#TO6botoobras ").removeClass("transiopaca");
            $("#TO6hold3 ").removeClass("transiopaca");
            $("#TO6hold4 ").removeClass("transiopaca");
            $("#TO6hold5 ").removeClass("transiopaca");
            setTimeout(function(){
              setTimeout(function(){
                $("#TO6hold5 ").addClass("transiopaca");
                setTimeout(function(){
                  $("#TO6hold4 ").addClass("transiopaca");
                  setTimeout(function(){
                    $("#TO6hold3 ").addClass("transiopaca");
                    setTimeout(function(){
                      $("#TO6botoobras ").addClass("transiopaca");
                      $("#TO6hold1 ").addClass("transiopaca");
                      setTimeout(function(){
                        $("#TO6hold1 ").removeClass("cc");
                        $("#TO6botoobras ").removeClass("cc");
                        $("#TO6hold3 ").removeClass("cc");
                        $("#TO6hold4 ").removeClass("cc");
                        $("#TO6hold5 ").removeClass("cc");
                        $("#TO6botomenu").slideDown();
                      },1000);
                    },1000);
    
    
                  },1000);
    
    
                },1000);
    
              },1000);
    
    
    
    
    
    
    
              }, 3000);
           
          });
    
          var qua = $('.resposta');
          var $target = $('.gatilhoObra'),
            animationClass = 'respostaGatilho',
            animationClass2 = 'respostaGatilho2',
            offset = $(window).height() * 1 / 10;
    
    
    
          function animeScroll() {
            $("#TO6desapa").fadeOut();
            
        
    
            setTimeout(
              function() 
              {
                var desaparecendo = 'todonone';
             
                $("#TO6desapa").fadeIn();
              }, 2000);
    
    
            var documentTop = $(document).scrollTop();
    
            $target.each(function (index) {
    
              var itemTop = $(this).offset().top;
    
              if (documentTop > itemTop - offset) {
                $("#TO6botoobras").addClass(animationClass2);
                
              }
              else{
                $("#TO6boto" + index).removeClass(animationClass);
                  
              }
    
              if (documentTop > itemTop - offset) {
                $("#TO6boto" + index).addClass(animationClass);
                
                if (documentTop > itemTop * 2 - offset * 2) {
                  $("#TO6boto" + index).removeClass(animationClass);
                  
                }
                if (documentTop > itemTop){
                  $("#TO6boto" + index).removeClass(animationClass);
                  
                }
              }
            }
    
            
    
            );
          }
    
         
    
          $(document).scroll(debounce(function () {
            animeScroll();
          }, 200));
        })();
    
    
        $('.bolinhas a[href^="#TO6"]').on('click', function (e) {
          e.preventDefault();
          var id = $(this).attr('href'),
            targetOffset = $(id).offset().top;
    
          $('html, body').animate({
            scrollTop: targetOffset - 0
          }, 500);
        });
    
        $('.grandeMenu a[href^="#TO6"]').on('click', function (e) {
          e.preventDefault();
          var id = $(this).attr('href'),
            targetOffset = $(id).offset().top;
    
          $('html, body').animate({
            scrollTop: targetOffset - 0
          }, 500);
        });
      }
    render() {
        return (
            <div id="TO6obra1" className="displayTO6 gatilhoObra"> {this.props.children}
                <div id="TO6local1"className="videolocalTO6" style={{backgroundImage: 'url(' + {Dt2} +')'}}>
                <div class="sidebar-wrapper">
                        <div class="sidebar">
                            <h3> 2018 - 2019   </h3>
                            <h2 class="sidebar-titulo">MINI PAREDÃO ELETRÔNICO </h2>
                            <p class="descricao"> Instalação processual e performativa  transportável que apresenta  miniespetáculos sonoros luminosos com performances variadas ativadas através de comandos celulares e de agenciamento interativo. É uma miniatura  da estrutura  Paredão (sound system),  que misturas características do paredão nordestino e de Goiás, em uma hibridização ficcional. Apresenta interações via celulares diversas (envio de mensagens e interação sonora). </p>
                            <a className="botaops"  href="https://editor.p5js.org/10Dimensoes/present/gQqP2G2x9">obra interativa</a>
                        </div>
                        <div class="menuuu" id="menuuu"><i class="fa fa-bars fa-2x">
                        <img className="ring button" src={seta} alt=""/>
                        
                            
                            
                            
                            
                            </i></div>
                    </div>




                    <div className="tampavideoTO6">
                    </div>
                    <div className="ffechar todonone">
                       <i> FECHAR </i>
                    </div>
                    <div className="videoTO6" >
                        <video controlsList = "nofullscreen nodownload noremoteplayback" poster="a" id="TO6video" playsInline autoPlay muted loop>
                            <source src={paredao_bueno} type="video/mp4">
                            </source>
                        </video>
                    </div>
                    <div className="sobrepo1TO6"></div>
                    <div className="sobrepo2TO6"></div>
                    <div className="sobrepo3TO6"></div>
                </div>
                <div id="TO6desapa" className="magazineTO6">
                    
          
                </div>
                <div className="magazinenova" id="TO6magazinenova">
                    <div id="TO6dimensao"className="controleremoto">
                        <img src={controleremoto} alt=""/>
                    </div>
                    <div id="TO6dimensao2"className="controleremoto2 todonone">
                    <img src={controleremoto} alt=""/>
                        
                </div>
                </div>
            </div>
        );
    }
}
 
export default EstruturaTO6  ;